import { apiFetchFull, api } from './client'

export interface Shipment {
  id: number
  order_id: number
  order_number?: string
  deliverer: string
  tracking_code?: string
  status: 'ausstehend' | 'versendet' | 'zugestellt' | 'retoure' | string
  shipped_at?: string
  created_at: string
  updated_at: string
}

export interface ShipmentListParams {
  status?: string
  search?: string
  min_id?: number
  limit?: number
}

export interface ShipmentListResult {
  shipments: Shipment[]
  has_more: boolean
  next_min_id?: number
}

export async function listShipments(params: ShipmentListParams = {}): Promise<ShipmentListResult> {
  const qs = new URLSearchParams()
  if (params.status && params.status !== 'alle') qs.set('filter[status]', params.status)
  if (params.search) qs.set('filter[q][contains]', params.search)
  if (params.min_id) qs.set('pagination[min_id]', String(params.min_id))
  qs.set('pagination[limit]', String(params.limit ?? 50))

  const res = await apiFetchFull<Shipment[]>(`/shipping/?${qs.toString()}`)
  return {
    shipments: res.data ?? [],
    has_more: res.pagination?.has_more ?? false,
    next_min_id: res.pagination?.next_min_id as number | undefined,
  }
}

export async function getShipment(id: string): Promise<Shipment> {
  return api.get<Shipment>(`/shipping/${encodeURIComponent(id)}/`)
}

// DHL tracking URL builder
export function getDHLTrackingUrl(trackingCode: string): string {
  return `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?idc=${encodeURIComponent(trackingCode)}`
}
